export { default } from './menu-footer';